module.exports = __webpack_public_path__ + "static/media/speakers4.b5685b54.jpg";